export class LkpRevenueModel{
revcode = '' ;
revname = '' ;
revnotes = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;

}
